import axios from 'axios';

const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin + '/api';
  }
  return process.env.REACT_APP_BACKEND_URL + '/api';
};

export const API = getApiUrl();

// Global timeout for ALL axios requests - prevents stale cached code from using old short timeouts
axios.defaults.timeout = 60000;
